import React, {Component} from 'react';

import styles from '../../static/css/componentStyleModules/modalComponent.module.scss';

export default class DialogComponent extends Component {

    constructor(props){
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <div className={styles['modalBase']}>
              <div className={styles['modalBody'] + ' ' +  styles['dialogModal']}>
                <div className={styles['questionArea']}>
                  {this.props.question}
                </div>
                <div className={styles['answerArea']}>
                  {this.props.answers.map((value,index) => {
                      return(
                          value.isGhostStyle
                          ? (
                            <div className={styles['dialogButton'] + ' ' + styles['ghostStyle']} onClick={value.onButtonClick} key={index}>
                              {value.display}
                            </div>
                            )
                          : (
                            <div className={styles['dialogButton']} onClick={value.onButtonClick} key={index}>
                              {value.display}
                            </div>
                          )
                      )
                  })}
                </div>
              </div>
            </div>
        )
    }

};

// Propsのデフォルト値
DialogComponent.defaultProps = {
    question:'どうですか？',
    answers:[
        {display:'OK',isGhostStyle:false, onButtonClick:() => {console.log('buttonOne');}},
        {display:'キャンセル', isGhostStyle:true, onButtonClick:() => {console.log('buttonTwo');}},
    ],
};
